module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setup_account":"setup account","job_list":"Job list","no_transactions_found":"No transactions found","main_page":"main page"},"id":{}}')
  delete Component.options._Ctor
}
